export default
{
  title: 'Zu- Abschläge',
  name: 'Zu-Abschlag',
  factory: 'Zu-Abschlag Betrieb',
  slaughter: 'Zu-Abschlag Schlachthof',
  tax: 'USt',
  taxFromPerson: 'USt von Person',
  excludeHalfes: 'Hälften ausschließen',
  excludeReturns: 'Retouren ausschließen',
  properties: {
    NetWeight: 'Nettogewicht',
    Mfa: "MFA",
    ArticleAddition: "Artikelzuschlag"
  },
  notification: {
    save: {
      type: 'success',
      message: 'Zu- Abschlag erfolgreich gespeichert',
      title: 'Erfolgreich gespeichert'
    },
    delete: {
      type: 'success',
      message: 'Zu- Abschlag erfolgreich gelöscht',
      title: 'Erfolgreich gelöscht'
    },
    copy: {
      type: 'success',
      message: 'Zu- Abschlag erfolgreich kopiert',
      title: 'Erfolgreich kopiert'
    },
    updateAccount: {
      type: 'success',
      message: 'Zu- Abschlag Konto erfolgreich gespeichert',
      title: 'Erfolgreich gespeichert'
    }
  }
}
